module.exports = __webpack_public_path__ + "static/trade-unlimited-458a009cc84875e6e602ee2eca67d778.png";